"use client";

import React, { useCallback } from "react";

/**
 * Client component button to open Cookiebot consent dialog.
 * Separated from the server component to use useCallback and window access.
 */
const defaultClassName =
  "inline-flex items-center px-4 py-2 bg-brand-solid hover:bg-brand-hover text-white font-medium rounded-lg transition-colors";

type CookieSettingsButtonProps = {
  className?: string;
  label?: string;
};

export default function CookieSettingsButton({
  className = defaultClassName,
  label = "Update Cookie Preferences",
}: CookieSettingsButtonProps): React.JSX.Element {
  const handleCookieSettings = useCallback(() => {
    if (typeof window !== "undefined" && window.Cookiebot) {
      window.Cookiebot.renew();
    }
  }, []);

  return (
    <button
      onClick={handleCookieSettings}
      className={className}
      type="button"
    >
      {label}
    </button>
  );
}

